import React, { useEffect } from "react";
import ImageGalleryT from "../ImageGalleyT";

const Modal = ({
  show,
  onClose,
  articulo,
}) => {

  const [descripcion = "N/A", volumen = "N/A", ventajas = "N/A", datosTecnicos = "N/A"] =
  (articulo?.DescripcionLarga || "")
    .split("||")
    .map(str => str?.trim());

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [show]);

  const formatTextWithLineBreaks = (text) => {
    if (!text) return "N/A";
    return text.replace(/\. (?=[A-ZÁÉÍÓÚÑ])/g, '.\n');
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show audi-modal-overlay"
      style={{ display: "block" }}
      tabIndex="-1"
      role="dialog"
    >
      <div
        className="modal-dialog modal-xl modal-dialog-centered"
        role="document"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content audi-modal-content p-4 p-md-5">
          <div className="modal-header-wrapper w-100 d-flex justify-content-end mb-4">
            <button
              type="button"
              className="btn-close btn-close-modal"
              aria-label="Close"
              onClick={onClose}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-x"
                viewBox="0 0 24 24"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
          <div className="container">
            <div className="row row-cols-1 row-cols-md-2 details">
              {articulo.Activo ? (
                <>
                  <div className="col details__info pe-md-3">
                    <h2 className="audi-modal-title">
                      {articulo?.Nombre || "Título del artículo"}
                    </h2>
                    <p className="audi-modal-subtitle">
                      No. de Artículo: {articulo?.NumParte || "N/A"}
                    </p>
                  </div>
                  <div className="col details__image modal__image-container ps-md-3">
                    <div className="modal-image-wrapper">
                      <ImageGalleryT
                        articuloNuevo={articulo.Nuevo}
                        imagesArticulo={articulo.imgs.data[articulo.imgs.data.length - 1]}
                      />
                    </div>
                  </div>
                </>
              ) : (
                <h2>Articulo no disponible</h2>
              )}
            </div>
            <div className="row">
              <div className="col pe-md-3">
                <div className="audi-modal-body">
                  <p>
                    <strong>Descripción:</strong><br />
                    {descripcion}
                  </p>

                  <p>
                    <strong>Volumen de suministro:</strong><br />
                    {formatTextWithLineBreaks(volumen).split('\n').map((line, i) => (
                      <React.Fragment key={i}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                  </p>

                  <p>
                    <strong>Ventajas:</strong><br />
                    {formatTextWithLineBreaks(ventajas).split('\n').map((line, i) => (
                      <React.Fragment key={i}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                  </p>

                  <p>
                    <strong>Datos técnicos:</strong><br />
                    {formatTextWithLineBreaks(datosTecnicos).split('\n').map((line, i) => (
                      <React.Fragment key={i}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
